import { storeToRefs } from "pinia";
import { watch, onBeforeMount } from "vue";

import { useAuthStore, useNotificationsStore } from "@/entities";
import { hasToken } from "@/pages";
import { isFunction, mapErrorFromServer } from "@/shared";

export const useAuth = ({ onAuthenticate = null, onAuthorize = null } = {}) => {
    const authStore = useAuthStore();
    const notify = useNotificationsStore();
    const { setAuthenticated, setAuthorized } = authStore;
    const { isAuthenticated, isAuthorized } = storeToRefs(authStore);

    watch(isAuthenticated, async () => {
        try {
            if (isAuthenticated.value) {
                if (isFunction(onAuthenticate)) await onAuthenticate();

                setAuthorized(true);

                if (isFunction(onAuthorize)) onAuthorize();
            }
        } catch (error) {
            notify.setErrorNotify(mapErrorFromServer(error));
        }
    });

    onBeforeMount(() => {
        if (hasToken()) {
            setAuthenticated(true);
            // TODO: Раскоментировать и проверить
            // authStore.refreshUser();
        }
    });

    return { isAuthenticated, isAuthorized };
};
